import { theme } from '@themes/main';

export type VariantType =
  | keyof typeof theme.fontSizeWeightMap
  | keyof typeof theme.fontSizeLineHeightMap
  | keyof typeof theme.fontSizes;

export const tagsMap = {
  body1: 'p',
  body2: 'p',
  body3: 'p',
  body4: 'p',
  body5: 'p',
  body6: 'p',
  body7: 'p',
  body8: 'p',
  body9: 'p',
  body10: 'p',
  body11: 'p',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  paragraph1: 'p',
  paragraph2: 'p',
  subtitle1: 'p',
  subtitle2: 'p',
};

export function isVariantWithTag(
  variant: VariantType,
): variant is keyof typeof tagsMap {
  return variant in tagsMap;
}
